class BrandAPI {
    static get brand() {
        throw new Error('You have to implement the method brand()!');
    }
}

export {BrandAPI};
